import { useNavigate } from "react-router-dom";
import { BRAND_NAME } from "../../global/Globalapi";
import StickyContactTree from "../DynamicComp/StickyComponentTree";
const Footer = () => {
    const navigate = useNavigate();

    const adminLogin=()=>{
        navigate("/adminuser");
    }
    const affiliateLogin=()=>{
        navigate("/affiliateLogin");
    }
    const AffiliateUserReg=()=>{
        navigate("/AffiliateUserLogin");
    }   
    // return (
    //     <footer className="footer-bg"> 
    //         <div className="flex justify-center space-x-9">
    //             <p className="cursor-pointer hover:text-gray-400 mt-3" onClick={adminLogin}>Login</p>
    //             <p className="cursor-pointer hover:text-gray-400 mt-3" onClick={affiliateLogin}>AffiliateLogin</p>
    //             <p className="cursor-pointer hover:text-gray-400 mt-3" onClick={AffiliateUserReg}>AffiliateRegister</p>
                
    //             <p className="cursor-pointer hover:text-gray-400 mt-3" >Contact Us</p>
    //         </div>
    //         <p className="text-sm mt-3">© 2025 Bolt & Brook. All Rights Reserved.</p>
    //     </footer>
    // );
    return (
//   <footer className="footer-bg px-4 py-4">
    
//     {/* Links */}
//     <div
//       className="
//         flex flex-col items-center gap-3
//         md:flex-row md:justify-center md:space-x-9 md:gap-0
//       "
//     >
//       <p
//         className="cursor-pointer hover:text-gray-400"
//         onClick={adminLogin}
//       >
//         Login
//       </p>

//       <p
//         className="cursor-pointer hover:text-gray-400"
//         onClick={affiliateLogin}
//       >
//         Affiliate Login
//       </p>

//       <p
//         className="cursor-pointer hover:text-gray-400"
//         onClick={AffiliateUserReg}
//       >
//         Affiliate Register
//       </p>

//       <p className="cursor-pointer hover:text-gray-400">
//         Contact Us
//       </p>
//     </div>

//     {/* Copyright */}
//     <p className="text-sm mt-4 text-center">
//       © 2025 Bolt & Brook. All Rights Reserved.
//     </p>
//   </footer>
<div>
<footer className="footer-bg px-4 py-4">
  {/* Links */}
  <div
    className="
      flex flex-wrap justify-center items-center
      gap-x-6 gap-y-2
      text-sm
      md:flex-row md:space-x-9 md:gap-y-0
    "
  >
    <p
      className="cursor-pointer hover:text-gray-400"
      onClick={adminLogin}
    >
      Login
    </p>

    {/* <p
      className="cursor-pointer hover:text-gray-400"
      onClick={affiliateLogin}
    >
      Affiliate Login
    </p> */}

    {/* <p
      className="cursor-pointer hover:text-gray-400"
      onClick={AffiliateUserReg}
    >
      Affiliate Register
    </p> */}

    <p className="cursor-pointer hover:text-gray-400">
      Contact Us
    </p>
  </div>

  {/* Copyright */}
  <p className="text-xs md:text-sm mt-3 text-center">
    {/* © 2025 Bolt & Brook. All Rights Reserved. */}
    © 2025 {BRAND_NAME}. All Rights Reserved.
  </p>
</footer>
<StickyContactTree />
</div>
);

};

export default Footer;